import '@babel/polyfill';
import 'little-loader';
import 'react';
import 'prop-types';
import 'react-dom';
import 'react-router';
import 'spin.js';
import 'redux';
import 'redux-thunk';
import 'react-redux';
import 'react-router-redux';
if (DEBUG) {
    require('redux-logger');
}
import 'react-intl';
import 'react-intl/locale-data/en.js';
import 'react-intl/locale-data/fi.js';
import 'react-intl/locale-data/sv.js';
import '../static/font-awesome-extended';
import '../static/fonts/fonts.css';
(function (name) { return import(/* webpackMode: "eager" */'../static/img/' + name) })('logo'); // force webpack to import all stuff from static/img
import '../static/typed';
import 'react-day-picker';
import 'react-day-picker/lib/style.css';
import 'react-dropzone-component';
import 'dropzone';
import 'moment/src/moment';
// import 'moment/src/locale/en'; // included by default
import 'moment/src/locale/fi';
import 'moment/src/locale/sv';
import 'lodash.debounce';
import 'marked';
import { SketchPicker } from 'react-color';
import 'dom-to-image';
import '@sentry/react';
import '@sentry/tracing';